export const SEARCH_ENDPOINT = 'funnel/api/query';
export const AUTH_STATUS_ENDPOINT = 'funnel/api/query/auth-status';
export const AIRPORTS_ENDPOINT = 'funnel/api/query/search/airports';
